import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PostLoginRedirectService } from '@core/services/post-login-redirect.service';
import { PolicyService } from '@core/services/policy.service';

export const PolicyGuard: CanActivateFn = (_route, state) => {
  const policyService = inject(PolicyService);
  const postLoginRedirectService = inject(PostLoginRedirectService);

  if (!policyService.isPolicyAccepted()) {
    return postLoginRedirectService.createTermsOfUseUrlTree(state.url);
  }

  return true;
};
